<template>
<div class="app">
<slot></slot>
</div>
</template>

<script>
export default {
  name: "yzManageBar"
}
</script>

<style lang="less" scoped>
.app{
  display: flex;
  height: 58px;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
}
</style>
